/* eslint-disable react/prop-types */
import React from "react";
import ReleasesTable from "./ReleasesTable";

export default function ApprovalReview() {
  return (
    <>
      <ReleasesTable
        filterBy="Final Internal Controls"
        approval_status="Approval Released"
        title="Approval Review"
        query_type="select_by_status"
        return_status="approvals Reviewed Returned"
        showHistoryTab={true}
      />
    </>
  );
}
